import {Fragment, lazy, Suspense} from 'react'

import PropTypes from 'prop-types'

import {MoleculeModalContent, moleculeModalSizes} from '@s-ui/react-molecule-modal'

import {SELECT_POPOVER_CLASS_NAME} from '../config.js'

const LazyModal = lazy(() => import(/* webpackChunkName: "SelectPopoverModal" */ '@s-ui/react-molecule-modal'))

const SelectPopoverModalContentWrapper = ({actions, content, isOpen, setIsOpen}) => {
  const handleModalCancel = () => {
    setIsOpen(false)
  }

  return (
    isOpen && (
      <Suspense fallback={Fragment}>
        <div className={`${SELECT_POPOVER_CLASS_NAME}-modal`}>
          <LazyModal
            closeOnEscKeyDown
            closeOnOutsideClick
            fitWindow
            isContentless
            isOpen={isOpen}
            isPageScrollable={false}
            onClose={handleModalCancel}
            size={moleculeModalSizes.LARGE}
          >
            <MoleculeModalContent withoutIndentation>
              <div className={`${SELECT_POPOVER_CLASS_NAME}-modalContent`}>{content}</div>
            </MoleculeModalContent>
            <div className={`${SELECT_POPOVER_CLASS_NAME}-modalFooterActions`}>{actions}</div>
          </LazyModal>
        </div>
      </Suspense>
    )
  )
}

SelectPopoverModalContentWrapper.propTypes = {
  actions: PropTypes.node,
  content: PropTypes.node,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func
}

export default SelectPopoverModalContentWrapper
